const SAP_API = '/api/sapaddress/v1';

export const ORIGIN_ADDRESS_REVERSE_LOOKUP_API_URL = SAP_API + '/originaddress';
export const ORIGIN_ADDRESSES_API_URL = SAP_API + '/addresses';
